import Component from '../core/Component'
import Scroll from '../services/Scroll'

let Scrollbar = null

const STATES = {
    OPEN: 'is-open'
}

//otevirani+zavirani dropdownu
//automaticky zavirani na zmene
//zavirani ostatni dropdownu
export default class Dropdown extends Component {
    constructor(element, options = {}) {
        super(element, options = {
            closeOtherOnOpen: true,
            closeOnChange: false,
            limit: null,
            ...options
        })

        this.timer = null
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
    }

    handleOuterClick = event => {
        if (this.element.contains(event.target)) {
            return
        }

        this.close()
    }

    handleChange = () => {
        if (this.options.closeOnChange) {
            this.close()
        }
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        if (this.is(STATES.OPEN)) {
            return
        }
        this.element.classList.add(STATES.OPEN)
        this.attachListVirtualScroll()
        const openerEls = [...document.querySelectorAll(`[data-target="${this.element.id}"]`)]
        const openers = openerEls.map(openerEl => Component.getFromElement(openerEl))
        openers.forEach(opener => opener.addOpenClass())

        if (this.options.closeOtherOnOpen) {
            const dropdownEls = [...document.querySelectorAll(`[data-component="Dropdown"]`)]
            const dropdowns = dropdownEls.map(dropdownEl => Component.getFromElement(dropdownEl)).filter(dropdown => dropdown !== this)
            dropdowns.forEach(dropdown => dropdown.close())
        }

        this.timer = setTimeout(() => {
            document.addEventListener('click', this.handleOuterClick)
        }, 1000);
    }

    close() {
        clearTimeout(this.timer)
        if (!this.is(STATES.OPEN)) {
            return
        }
        this.element.classList.remove(STATES.OPEN)
        const openerEls = [...document.querySelectorAll(`[data-target="${this.element.id}"]`)]
        const openers = openerEls.map(openerEl => Component.getFromElement(openerEl))
        openers.forEach(opener => opener.removeOpenClass())
        document.removeEventListener('click', this.handleOuterClick)
    }

    async attachListVirtualScroll() {
        if (this.virtualScrollbar) {
            return
        }

        if (!Scroll.isVirtual) {
            return
        }

        if (!Scrollbar) {
            try {
                const module = await import(
                    /* webpackChunkName: "virtualscroll-smoothscroll" */
                    'smooth-scrollbar'
                )
                Scrollbar = module.default
            } catch (error) {
                throw 'Unable to load smoothscroll'
            }
        }

        this.virtualScrollbar = Scrollbar.init(this.element)
    }
}